import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import PortfolioModal from "./PortfolioModal";

const PortfolioAnimation = () => {
  const [isOpen, setOpen] = useState(false);
  const [isOpen2, setOpen2] = useState(false);
  const [portfolioToShow, setPortfolioToShow] = useState(null);

  const toggleModal = (data) => {
    if (data) {
      setPortfolioToShow(data);
      setOpen(!isOpen);
    } else {
      setPortfolioToShow(null);
      setOpen(!isOpen);
    }
  };

  const portfolioData = [
    {
      title: "EKYC",
      subtitle: "SaaS based KYC Application",
      timeline: `May 2022 - Present`,
      team: `Implevista`,
      cover: "img/portfolio/8.jpg",
      thumbnail: "img/portfolio-thumbnails/8.jpg",
      description: `<p><strong>eKYC (Electronic Know Your Customer)</strong> refers to a remote and paperless process designed to streamline and modernize traditional KYC procedures, minimizing associated costs and bureaucratic hurdles. It encapsulates the digitalization and online transformation of KYC processes.</p>
      <p>This endeavor presents a <strong>SaaS-based solution</strong> tailored for organizations seeking efficient customer data management. Companies can readily establish their personalized eKYC portal along with an intuitive Admin Panel.</p>
      <p>🔥 <strong>Key Highlights:</strong></p>
      <ul>
        <li><strong>Multi-Tenant Architecture:</strong> This project boasts a robust multi-tenant architecture, accommodating multiple organizations. Distinct databases are maintained alongside a central master database. Organizations are seamlessly linked through DNS records stored in the master database.</li>
        <li><strong>Integration of 3rd Party APIs:</strong> Essential functionalities entail data validation, verification, and retrieval from select APIs such as BSE, CVLKRA, CDSL, NSDL, DIGILOCKER, and Penny Drop.</li>
        <li><strong>Comprehensive KYC Process:</strong> The application adeptly gathers comprehensive user information, including PAN card details, Aadhar Card information, contact details, documentary proof, and conducts thorough video and photo verifications.</li>
      </ul>
      <br />
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>React.js</li>
        <li>Node.js (Express)</li>
        <li>Redux</li>
        <li>MySQL</li>
      </ul>
      `,
      projectUrl: "https://ekyc.balajiequities.com",
    },
    {
      title: "Cash Transfer",
      subtitle: "Cash Transfer Approval System",
      timeline: `September 2022 - January 2023`,
      team: `Personal`,
      cover: "img/portfolio/13.png",
      thumbnail: "img/portfolio-thumbnails/13.jpg",
      description: `<p><strong>This project entails an Approval System tailored for financial organizations seeking governmental authorization for inter-organizational money transfers. The solution encompasses a web application, an admin panel, and a mobile app equipped with a QR code scanner.</strong></p>
      <p><strong>Financial institutions can initiate transfer requests through the app. Based on the approval process, they can secure an approval certificate featuring a QR code. This QR code serves as a verification tool for customs authorities.</strong></p>
      <p>🔥 <strong>Key Highlights:</strong></p>
      <ul>
        <li><strong>QR Code Generation:</strong> Every transfer request generates a distinct approval form, accompanied by a unique QR code. This QR code can be authenticated using the mobile app, enhancing security and verification.</li>
        <li><strong>Comprehensive Report Generation:</strong> The application possesses advanced reporting capabilities, providing multi-dimensional insights. It can also produce user certificates functioning as licenses.</li>
        <li><strong>Flexible Dynamic User Authorization:</strong> The app boasts dynamic user role management, offering extensive flexibility in defining user privileges.</li>
      </ul>
      <br />
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>React.js</li>
        <li>Node.js (Express)</li>
        <li>Redux</li>
        <li>MongoDB</li>
        <li>React Native</li>
      </ul>      
      `,
    },
    {
      title: "Click Courses",
      subtitle: "Learning Management System",
      timeline: `February 2022 - November 2022`,
      team: `Personal`,
      cover: "img/portfolio/12.png",
      thumbnail: "img/portfolio-thumbnails/12.jpg",
      description: `<p><strong>Click Courses</strong> stands as an advanced Learning Management System, encompassing a bespoke application complete with a backend infrastructure and an intuitive admin panel within its web-based framework.</p>
      <p>This comprehensive platform empowers instructors to craft and manage courses, while providing students with the ability to seamlessly enroll in these courses. The system is rich with dynamic features including live classes, quizzes, real-time chat functionality, and much more.</p>
      <p>🔥 <strong>Key Highlights:</strong></p>
      <ul>
        <li><strong>Quiz Functionality:</strong> Experience uninterrupted live quizzes, enabling students to engage within predefined timeframes and receive automatic results upon quiz completion.</li>
        <li><strong>Real-time Chat:</strong> Foster real-time communication between students and educators, including the convenience of course-specific group chat functionality.</li>
        <li><strong>Comprehensive Course Reports:</strong> The platform offers the capability to generate detailed reports for individual students based on their quiz performance, assignment submissions, and attendance records.</li>
      </ul>
      <br />
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>React.js</li>
        <li>Node.js (Express)</li>
        <li>Redux</li>
        <li>MongoDB</li>
        <li>Socket.io</li>
        <li>Zoom API</li>
      </ul>      
      `,
    },
    {
      title: "My Diagonostic",
      subtitle: "Shopify Based E-Commerce for Diagnostic Services",
      timeline: `May 2022 - Decemeber 2022`,
      team: `Personal`,
      cover: "img/portfolio/14.png",
      thumbnail: "img/portfolio-thumbnails/14.jpg",
      description: `<p><strong>My Diagnostic</strong> represents an E-Commerce platform specialized in Diagnostic Services, built on the Shopify infrastructure. This bespoke application integrates a tailored backend, an intuitive admin panel, and a complementary mobile app, seamlessly bridging connectivity with the Shopify ecosystem.</p>
      <p>This robust framework facilitates the extraction and management of Shopify app data via the admin panel, while also offering extended functionality through the mobile application.</p>
      <p>🔥 <strong>Key Highlights:</strong></p>
      <ul>
        <li><strong>Shopify Integration:</strong> The project establishes a dynamic connection with a Shopify store through the Shopify-provided API. This enables the retrieval and manipulation of Shopify data to enhance user experiences.</li>
        <li><strong>Interactive Quizzes:</strong> The platform offers a quiz creation feature, providing users with automatic result generation. Mobile app users can participate in quizzes, earning reward points based on their performance.</li>
        <li><strong>Fitness Tracking:</strong> The mobile app introduces fitness tracking functionality, enabling users to log regular activities. It leverages this data to offer health-related product suggestions from the Shopify store and even provides recommendations for medical professionals.</li>
      </ul>
      <br />
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>React.js</li>
        <li>Node.js (Express)</li>
        <li>Redux</li>
        <li>MongoDB</li>
        <li>Shopify API</li>
        <li>React Native</li>
      </ul>      
      `,
    },
    {
      title: "Global Expert App",
      subtitle:
        "Internal Audit Management Enterprise Application of Holcim International",
      timeline: `Jan 2022 - Present`,
      team: `Implevista`,
      cover: "img/portfolio/9.jpg",
      thumbnail: "img/portfolio-thumbnails/9.jpg",
      description: `<p><strong>This project represents an enterprise application developed for Holcim International, catering to the organization's internal audit needs across various inventory sites. The application is designed as a versatile cross-platform solution, accessible both through mobile and web platforms, built on Ionic framework and TypeScript.</strong></p>
      <p>🔥 <strong>Key Highlights:</strong></p>
      <ul>
        <li><strong>Efficient Drafting:</strong> Simplifying inventory creation, users have the flexibility to save incomplete inventory data as drafts. Additionally, users within the same location can collaboratively work on and continue each other's drafts.</li>
        <li><strong>Role-based Access Control:</strong> The application employs a comprehensive role system, assigning users specific roles across different locations. Users can hold multiple roles across various locations, influencing their access and navigation within the system.</li>
        <li><strong>Seamless Cloud Function Scheduler:</strong> Seamlessly integrating with an internal system via API, this application maintains continuous data synchronization through a sophisticated scheduler mechanism.</li>
      </ul>
      <br />
      <p>💡 <strong>Technologies Utilized:</strong></p>
      <ul>
        <li>Firebase Cloud Functions as API Service</li>
        <li>Firestore as Database</li>
        <li>Firebase Storage as Storage Bucket</li>
        <li>Typescript</li>
        <li>Angular Ionic</li>
      </ul>
      `,
    },
    {
      title: "IV CMS",
      subtitle: "Implevista Content Management system",
      timeline: `Sep 2021 - Present`,
      team: `Personal Project`,
      cover: "img/portfolio/11.jpg",
      thumbnail: "img/portfolio-thumbnails/11.jpg",
      description: `<p><strong>This project entails an internal Content Management Application developed using Next.js and Node.js. Serving as a search engine optimized solution, the application serves as a platform to showcase the organization's portfolios and case studies.</strong></p>
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>Next.js</li>
        <li>React.js</li>
        <li>MongoDB</li>
        <li>Node.js (Express)</li>
      </ul>
      `,
      projectUrl: "https://implevista.com",
    },
    {
      title: "Implevista Commerce",
      subtitle: "SaaS Based Multipurpose E-Commerce with Theme Support",
      timeline: `Nov 2020 - Present`,
      team: `Implevista`,
      cover: "img/portfolio/7.jpg",
      thumbnail: "img/portfolio-thumbnails/7.jpg",
      description: `<p><strong>IVCommerce</strong> is a cutting-edge SaaS-based e-commerce platform offering seamless customizability through theme support. This versatile solution welcomes businesses of all kinds to effortlessly join the platform by subscribing to the application. It caters to single-vendor and multi-vendor setups, accommodating both B2B and B2C business models. Developed in-house by Implevista Ltd., IVCommerce stands as a powerful offering.</strong></p>
      <p>🔥 <strong>Key Highlights:</strong></p>
      <ul>
        <li><strong>Robust Multi-Tenant Architecture:</strong> IVCommerce employs a sophisticated multi-tenant architecture to support numerous e-commerce ventures. Each business operates with its dedicated database and unique DNS configuration, enhancing individual site settings.</li>
        <li><strong>Dynamic Site Theme Customization:</strong> Every site possesses a tailored theme with customizable metadata. This empowers businesses to personalize their site's appearance and user experience.</li>
        <li><strong>Multi-Currency Support:</strong> IVCommerce seamlessly incorporates automatic currency conversion based on daily exchange rates, ensuring a global reach for businesses.</li>
        <li><strong>B2B and B2C Flexibility:</strong> The platform caters to both B2B and B2C business models, adapting to diverse commercial dynamics.</li>
        <li><strong>Real-time Chat Functionality:</strong> IVCommerce fosters real-time communication between sellers and customers, facilitating file sharing and requirement exchange.</li>
      </ul>
      <br />
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>Express.js (Node.js)</li>
        <li>React.js</li>
        <li>MongoDB</li>
        <li>Next.js</li>
        <li>Firebase</li>
        <li>Tailwind CSS</li>
        <li>Reactstrap</li>
      </ul>`,
      projectUrl: "https://ivcommerce.com",
    },
    {
      title: "Spin The Wicket",
      subtitle: "Wheel Spinning Cricket Tournament Game",
      timeline: `July 2020 - Present`,
      team: `Personal Project`,
      cover: "img/portfolio/1.jpg",
      thumbnail: "img/portfolio-thumbnails/1.jpg",
      description: `<p><strong>This project is the realization of a cherished childhood dream. Recalling days spent playing cricket using spun paper rounds as the basis for ball-by-ball action, a thought emerged - why not have mobile games for this unique experience? With the acquisition of coding skills, the journey began, resulting in a playable creation. Yet, the vision extends beyond, harboring a multitude of features.</strong></p>
      <p><strong>At present, the application offers quick online matches, enabling users to compete with international teams, adhering to authentic cricket rules. Additionally, the feature set includes franchise leagues, allowing the creation and management of teams for matches with friends. Leagues encompass rankings, tournaments, and comprehensive player and team statistics.</strong></p>
      <p><strong>The project is a work in progress, advancing until every imaginative aspect is meticulously translated into code. Currently, the project is a Progressive Web App built atop ReactJS and Firebase. A complementary mobile app is under development using React Native, introducing further enhancements.</strong></p>
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>ReactJS</li>
        <li>Firebase</li>
        <li>NodeJS</li>
        <li>Firebase Cloud Firestore</li>
        <li>Firebase Auth</li>
      </ul>`,
      projectUrl: "https://spin-the-wicket.web.app",
    },
    {
      title: "GoJam",
      subtitle: "Musical Practice Pad Booking System",
      timeline: `Jan 2020 - Apr 2020`,
      team: `Personal Project`,
      cover: "img/portfolio/2.jpg",
      thumbnail: "img/portfolio-thumbnails/2.jpg",
      description: `<p><strong>Presented here is a university project undertaken during my exploration of the MERN stack. This initiative revolves around facilitating the reservation of Jamming Pads for musical bands or groups.</strong></p>
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>React.js</li>
        <li>MongoDB</li>
        <li>Node.js (Express)</li>
      </ul>`,
      projectUrl: "https://github.com/ahmmedabir9/pad-booking-system",
    },

    {
      title: "Real-time Chat App",
      subtitle: "React-Node Chat Application using Socket.io",
      timeline: `Apr 2020 - May 2020`,
      team: `Personal Project`,
      cover: "img/portfolio/4.jpg",
      thumbnail: "img/portfolio-thumbnails/4.jpg",
      description: `<p><strong>Highlighted here is a university project undertaken during my exploration of Node.js. The project materializes as a single-vendor e-commerce web application, catering to a clothing store's needs.</strong></p>
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>Node.js (Express)</li>
        <li>MongoDB</li>
        <li>EJS</li>
      </ul>
      `,
      projectUrl: "https://github.com/ahmmedabir9/react-messenger",
    },
    {
      title: "Covid Update Tracker",
      subtitle: "ReactJS Covid Statistic Tracker using 3rd party API",
      timeline: `Apr 2020 - May 2020`,
      team: `Personal Project`,
      cover: "img/portfolio/5.jpg",
      thumbnail: "img/portfolio-thumbnails/5.jpg",
      description: `<p><strong>During my exploration of websockets, I crafted this application leveraging Node.js and React.js. The project fosters socket connections, enabling the creation of real-time chat rooms between users.</strong></p>
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>Node.js (Express)</li>
        <li>React.js</li>
        <li>Socket.io</li>
      </ul>`,
      projectUrl: "https://ahmmedabir9.github.io/covid-19-update/",
    },
    {
      title: "Codeforces Contest Template",
      subtitle:
        "NodeJs Scrapper to prepare Contest Testcases with Solution Template of C++",
      timeline: `May 2020 - June 2020`,
      team: `Personal Project`,
      cover: "img/portfolio/10.jpg",
      thumbnail: "img/portfolio-thumbnails/10.jpg",
      description: `<p><strong>During my university years, while participating in Codeforces contests, I observed an opportunity to streamline the process. The need to repeatedly write test cases and template codes led me to develop this solution. This template automates the testing of JavaScript programs, extracting problem test cases from a provided contest link. It creates a directory containing all test cases and a C++ starter template code. Each problem corresponds to a dedicated directory. After coding, a simple click runs the test cases and provides instant results. This innovation offers substantial time savings for competitive programming, where every second is crucial.</strong></p>
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>Node.js</li>
      </ul>
      `,
      projectUrl: "https://github.com/ahmmedabir9/codeforces-problem-template",
    },
    {
      title: "Sheild20",
      subtitle: "Ecommerce Application",
      timeline: `Sep 2019 - December 2019`,
      team: `Personal Project`,
      cover: "img/portfolio/3.jpg",
      thumbnail: "img/portfolio-thumbnails/3.jpg",
      description: `<p><strong>During my journey of mastering Node.js, I embarked on a university project that resulted in the creation of a single-vendor e-commerce web application tailored for a clothing store.</strong></p>
      <p>💡 <strong>Utilized Technologies:</strong></p>
      <ul>
        <li>Node.js (Express)</li>
        <li>MongoDB</li>
        <li>EJS</li>
      </ul>
      `,
      projectUrl: "https://github.com/ahmmedabir9/captains-bd",
    },
  ];

  return (
    <SimpleReactLightbox>
      <div className="portfolio_list">
        <ul className="gallery_zoom">
          {/* End vimeo */}

          {portfolioData?.map((data) => (
            <li
              data-aos="fade-right"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              <div className="list_inner">
                <div className="overlay"></div>
                <img className="svg" src="img/svg/zoom.svg" alt="" />
                <div className="title">
                  <h3>{data.title}</h3>
                  <span>{data.subtitle}</span>
                </div>

                <a onClick={() => toggleModal(data)}>
                  <img src={data.thumbnail} alt={data.title} />
                </a>
              </div>
            </li>
          ))}

          {/* End image popup */}
        </ul>

        <PortfolioModal
          open={isOpen}
          toggle={toggleModal}
          portfolio={portfolioToShow}
        />
      </div>
    </SimpleReactLightbox>
  );
};

export default PortfolioAnimation;
